import { globalConstants, brandConfigurationConstants } from "../../constants";

//Destructuring global constants
const { SUCCESS, FAILURE } = globalConstants;

//Destructuring user permission constants
const { BRAND_CONFIGURATION_DATA, REFRESH_BRAND_CONFIGURATION } =
  brandConfigurationConstants;

//Default state of account reducer
const initialState = {
  brandConfigurationData: [],
  brandConfigurationPagination: {
    size: 10,
    totalElements: 0,
    number: 0,
  },
};

//Manipulating the state of account based on actions and returning the state
export const brandConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case BRAND_CONFIGURATION_DATA + SUCCESS:
      return {
        ...state,
        brandConfigurationData: action.data.data,
        brandConfigurationPagination: action.data.page,
      };
    case BRAND_CONFIGURATION_DATA + FAILURE:
      return {
        ...state,
        brandConfigurationData: [],
        brandConfigurationPagination: {
          size: 10,
          totalElements: 0,
          number: 0,
        },
      };
    case REFRESH_BRAND_CONFIGURATION:
      return {
        ...state,
        brandConfigurationData: action.data,
      };
    default:
      return state;
  }
};
